import React from "react";
import "./Activitse.css";
import AuctionActivity from "./AuctionActivity";
import LoadingSkeleton from "./LoadingSkeleton";

const ActivitiesContent5 = (props) => {
  return (
    <>
      <div className="row mt-3">
        {props.loader ? (
          props.event.map((event) => {
            return (
              <>
                <AuctionActivity event={event.auction} event_type="auction" />
              </>
            );
          })
        ) : (
          <LoadingSkeleton />
        )}
      </div>
    </>
  );
};

export default ActivitiesContent5;
